// extracted by mini-css-extract-plugin
export default {"heading":"Targeting_heading__rYgJX","wrapper":"Targeting_wrapper__4Mqwc"};